export enum RoutePath {
   BASE_URL = '/:locale([a-z]{2})',
   PARTNERS_PAGE = '/partner/:slug',
   LOCATION_PAGE = '/:slug',
   BOOK_FLOW_PAGE = '/:slug/checkout',
   PARTNER_BOOK_FLOW_PAGE = '/partner/:slug/checkout',
   APPOINTMENT_PAGE = '/appointment/:id/:entryToken',
}
